export const createBankSlice = (set) => ({
  bankAccId: null,
  storeBankAccId: (bankAccId) => set({ bankAccId }),
  clearBankAccId: () => set({ bankAccId: null }),
});
